export default __webpack_public_path__ + "static/media/helios.febfdbc6.png";